import React, { useState } from 'react'
import DashboardTable from './DashboardTable'
import * as XLSX from 'xlsx';
import moment from 'moment';
import { dummyDataClient } from './dummyClientData';

const PositionDashboard = () => {

    const [excelData, setExcelData] = useState(null);

    const headers = [
        'Sr.No', 'Position received date', 'Clarity call date', 'Position renew date', 'TAT to selection as per SLA',
        'Target Date of Selection', 'Candidate Date of selection', 'Revised Target Date of Selection', 'Actual TAT of selection',
        'TAT - Delay in selection', 'Reason of delay/HOLD', 'Select to offer TAT', 'Approx Offer date', 'Actual Offer date',
        'Official Notice Period', 'Approx DOJ', 'Actual DOJ candidate will join', 'Client', 'HR name/HM', 'Position Name',
        'Number of Positions', 'Current Active role', 'closed', 'Budget', 'Billable CTC', 'Commercial %', 'Billing amount per position',
        'Business Ensurity  (100/75/50/25) -%', 'Business Ensurity (actual revenue)', 'Status', 'Current delivery update',
        'Payment terms ( in days)', 'Approx Payment receiving date', 'Internal SPOC', 'Selected candidate name', 'Recruiter name'
      ];
    
      function excelDateToJSDate(serial) {
        const utc_days = Math.floor(serial - 25569); // Excel to Unix epoch (Jan 1, 1970)
        const utc_value = utc_days * 86400; // seconds
        return new Date(utc_value * 1000); // convert to ms
      }
    
        // Helper function to check if a value is a date serial number
        const formatDate = (value, columnName) => {
            // Define which columns are expected to have dates
            const dateColumns = [
              'Position received date', 'Clarity call date', 'Position renew date', 'Target Date of Selection',
              'Candidate Date of selection', 'Revised Target Date of Selection', 'Approx Offer date', 'Actual Offer date',
              'Approx DOJ', 'Actual DOJ candidate will join', 'Approx Payment receiving date'
            ];
    
        if (dateColumns.includes(columnName) && typeof value === 'number') {
        
            return moment(excelDateToJSDate(value)).format('DD-MMM-YY'); // Adjust the format as needed
          }
            return value; // If not a date, return the original value
          };
    
      const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const binaryString = event.target.result;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
    
            // Get the first sheet
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
    
            // Convert sheet to JSON, using first row as the header row
            const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
            // Map the data to an array of objects where the header is used as the key
            const structuredData = data.slice(18,389).map((row) => {
              let rowObject = {};
            //   row.forEach((cell, idx) => {
            //     rowObject[headers[idx]] = cell;
            //   });
                row.forEach((cell, idx) => {
                    const formattedValue = formatDate(cell, headers[idx]); // Format the value if needed
                    rowObject[headers[idx]] = formattedValue;
                });
              return rowObject;
            });
            
            console.log("Structured Dtaa",structuredData)
            setExcelData(structuredData); // Set the data in the state
          };
          reader.readAsBinaryString(file);
        }
      };
    
      return (
        <div >
          {/* <h1>Client Dashboard</h1> */}
          {/* <h1>Excel File Reader</h1>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} /> */}
          <DashboardTable data={dummyDataClient}/>
        </div>
      )
    }

export default PositionDashboard
